import {Component, EventEmitter, Input, Output} from "@angular/core";
import {FormsModule} from "@angular/forms";
import {NgIf} from "@angular/common";
import "firebase/compat/firestore";
import firebase from "firebase/compat";

@Component({
  selector: 'app-annual-school-profiles-card',
  templateUrl: './annual-school-profiles-card.component.html',
  standalone: true,
  imports: [
    FormsModule,
    NgIf
  ],
  styleUrl: './annual-school-profiles-card.component.css'
})

export class AnnualSchoolProfilesCardComponent {
  @Input() schoolName: string = '';
  @Input() teacherName: string = '';
  @Input() year: string = '';
  @Input() email: string = '';
  @Input() teacherList: any[] = [];
  @Input() project: firebase.firestore.DocumentReference[] = [];
  @Input() number: number = 1;
  @Output() cardClicked: EventEmitter<String> = new EventEmitter();

  onCardClick() {
    this.cardClicked.emit();
  }

  get projectEmpty(): boolean {
    return !this.project || this.project.length === 0;
  }

}
